export default '/build/7f830dfc.svg'